// extracted by mini-css-extract-plugin
export default {"buttonDisabled":"common_buttonDisabled__kZ4oM"};